import { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Alert,
  Grid,
  TextField,
  Button,
  IconButton,
  FormControl,
  FormHelperText,
  Select,
  Divider,
  Slider,
  Rating,
  TextareaAutosize,
  Avatar,
  MenuItem,
  Slide,
  Snackbar,
  Chip,
  Tooltip,
} from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useParams, useNavigate } from "react-router-dom";
import {
  Edit,
  AddCircleOutline,
  Close,
  Delete,
  DragIndicator,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDateFns as AdapterFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider as LocalizationProv } from "@mui/x-date-pickers/LocalizationProvider";
import { Circle, CircleOutlined } from "@mui/icons-material";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import FormLabel from "../../components/FormLabel";
// ** modals ** //
import EditExpertiseModal from "./PageModals/EditExpertiseModal";
import AddExpertiseModal from "./PageModals/AddExpertiseModal";
import EditExperienceModal from "./PageModals/EditExperienceModal";
import AddExperienceModal from "./PageModals/AddExperienceModal";
import EditToolsModal from "./PageModals/EditToolsModal";
import AddToolModal from "./PageModals/AddToolModal";
import AddLanguageModal from "./PageModals/AddLanguageModal";
import EditLanguageModal from "./PageModals/EditLanguageModal";
import AddNRModal from "./PageModals/AddNationalityReligionModal.js";
import AddProjectModal from "./PageModals/AddProjectModal";
import EditProjectModal from "./PageModals/EditProjectModal";
import AddEditSkillModal from "./PageModals/AddEditSkillModal";
// ** modals ** //
import { withStyles } from "@material-ui/core/styles";
import { styled } from "@mui/material/styles";
import "./create.css";
import axios from "../../config/axios";
import ProfilePreviewDialog from "./profilePreviewDialog";
import LoadingButton from "@mui/lab/LoadingButton";
import { getUserData, hasAccess } from "../../utils/utilities";
import "./CreatePrototype.css";

const styles = () => ({
  input: {
    height: 15,
    width: 100,
    textAlign: "center",
  },
});

const initData = {
  company: null,
  tools: [{ name: "Git And Bit Bucket", value: 75 }],
  languages: [],
  experience: 0,
  experienceDetails: [{ duration: "", tech: "" }],
  expertise: [],
  timeFrom: new Date(),
  timeTill: new Date(),
  graduationDate: new Date(),
  timeZone: "",
  location: "",
  availability: "",
};

// page custom components
const StyledRating = styled(Rating)({
  "& .MuiRating-iconFilled": {
    color: "#1497D4",
  },
  "& .MuiRating-iconHover": {
    color: "#1497D4",
  },
});

const FormRow = ({ children }) => (
  // for form row
  <Box style={{ marginBottom: "20px" }}>
    <Grid spacing={3} container>
      {children}
    </Grid>
  </Box>
);

const SpaceBetweenWrapper = ({ children }) => (
  <Grid
    spacing={3}
    container
    style={{
      display: "flex",
      justifyContent: "space-between",
    }}
  >
    {children}
  </Grid>
);

const formatDateYMD = (date) => {
  let month = date.getMonth() + 1;
  let d = date.getDate();
  if (month < 10) {
    month = `0${month}`;
  }
  if (d < 10) {
    d = `0${d}`;
  }
  if (isNaN(date.getFullYear()) || isNaN(d) || isNaN(month)) {
    return "";
  }
  return `${date.getFullYear()}-${month}-${d}`;
};

const getEmployeeProfilePic = async (id) => {
  const params = { id };
  const profilePic = await axios.get(
    "/employee-profile/get-employee-profile-pic",
    {
      params,
    },
  );

  console.log("📢[Create.js:130]: profilePic: ", profilePic);
};

const Create = withStyles(styles)((props) => {
  const userData = getUserData();
  const navigate = useNavigate();
  const abortController = useRef(new AbortController());
  // APP states
  const [activeSections, setActiveSections] = useState(['sec-basic']);
  const handleSectionClick = (id) => {
    setActiveSections((prev) => {
      if (prev.includes(id)) {
        return [];
      } else {
        return [id];
      }
    });
    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  };
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [employeeData, setEmployeeData] = useState({ ...initData });
  const [nationalityOptions, setNationalityOptions] = useState([]);
  const [enabledNationality, setEnabledNaitonality] = useState([]);
  const [expertiseOptions, setExpertiseOptions] = useState([]);
  const [enabledExpertiseOptions, setEnabledExpertiseOptions] = useState([]);
  const [religionOptions, setReligionOptions] = useState([]);
  const [enableReligions, setEnableReligions] = useState([]);
  const [skillOptions, setSkillOptions] = useState([]);
  const [languageOptions, setLanguageOptions] = useState([]);
  const [enableLanguageOptions, setEnableLanguageOptions] = useState([]);
  const [successMsg, setSuccessMsg] = useState(false);
  const [updateMsg, setUpdateMsg] = useState(false);
  const [displayAlert, setDisplayAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertVariant, setAlertVariant] = useState("success");
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showProfilePreviewDialog, setProfilePreviewDialog] = useState(false);
  const [previewSourcePath, setPreviewSourcePath] = useState("");
  const [generatingPreview, setGeneratingPreview] = useState(false);
  const [toolsList, setToolsList] = useState([]);
  const [companyId, setCompanyId] = useState("");
  const initialFormSnapshotRef = useRef("");
  const skipDirtyTrackingRef = useRef(true);
  // ── Template & Color customization state ────────────────────────────────
  const [cvTemplates, setCvTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [primaryColor, setPrimaryColor] = useState("");
  const [secondaryColor, setSecondaryColor] = useState("");

  const skipConfirmNavigationRef = useRef(false);

  useEffect(() => {
    if (!showProfilePreviewDialog) {
      setPreviewSourcePath("");
    }
  }, [showProfilePreviewDialog]);

  // ── Fetch CV templates from API on mount ─────────────────────────────
  useEffect(() => {
    axios
      .get("admin/cv-templates")
      .then((res) => {
        if (res.data?.data?.length) {
          setCvTemplates(res.data.data);
        }
      })
      .catch(() => {
        // Templates not available; will fall back to default
      });
  }, []);

  const buildFormSnapshot = (data = employeeData, skills = selectedSkills) =>
    JSON.stringify({
      ...data,
      timeFrom:
        data.timeFrom instanceof Date
          ? data.timeFrom.toISOString()
          : data.timeFrom || "",
      timeTill:
        data.timeTill instanceof Date
          ? data.timeTill.toISOString()
          : data.timeTill || "",
      graduationDate:
        data.graduationDate instanceof Date
          ? data.graduationDate.toISOString()
          : data.graduationDate || "",
      skills: [...(skills || [])],
    });

  const markFormAsSaved = (data = employeeData, skills = selectedSkills) => {
    initialFormSnapshotRef.current = buildFormSnapshot(data, skills);
    skipDirtyTrackingRef.current = false;
    setHasUnsavedChanges(false);
  };

  const { id } = useParams();
  // validation states
  const [totalExperienceValidation, setTotalExperienceValidation] = useState({
    status: false,
    msg: "",
  });
  const [validations, setValidations] = useState({});
  // modal states
  const [modalStatus, setModalStatus] = useState({
    editExpertise: false,
    addExpertise: false,
    addExperience: false,
    editExperience: false,
    addTool: false,
    editTools: false,
    addLanguage: false,
    editLanguages: false,
    addNR: false,
    editNR: false,
    addProject: false,
    editProjects: false,
  });

  // frontend form validation
  const validateForm = () => {
    const errors = {};

    if (!employeeData.company) {
      errors.company = { status: true, msg: "Company is required" };
    }

    if (!employeeData.name || !employeeData.name.trim()) {
      errors.name = { status: true, msg: "Employee name is required" };
    }

    if (
      !employeeData.expertise ||
      !employeeData.expertise.length ||
      !employeeData.expertise[0]
    ) {
      errors.expertise = {
        status: true,
        msg: "At least one designation is required",
      };
    }

    if (!employeeData.summary || !employeeData.summary.trim()) {
      errors.summary = { status: true, msg: "Profile summary is required" };
    }

    if (!employeeData.timeFrom || isNaN(employeeData.timeFrom.getTime())) {
      errors.timeFrom = { status: true, msg: "Start time is required" };
    }

    if (!employeeData.timeTill || isNaN(employeeData.timeTill.getTime())) {
      errors.timeTill = { status: true, msg: "End time is required" };
    }

    if (
      employeeData.experience === "" ||
      employeeData.experience === null ||
      employeeData.experience === undefined
    ) {
      errors.experience = { status: true, msg: "Total experience is required" };
    } else if (Number(employeeData.experience) < 0) {
      errors.experience = {
        status: true,
        msg: "Experience cannot be negative",
      };
    }

    if (Array.isArray(employeeData.experienceDetails)) {
      let hasDurationError = false;
      let hasTechError = false;
      employeeData.experienceDetails.forEach((detail) => {
        if (!String(detail.duration).length || detail.duration === "") {
          hasDurationError = true;
        }
        if (!detail.tech) {
          hasTechError = true;
        }
      });
      if (hasDurationError) {
        errors.duration = {
          status: true,
          msg: "Duration is required for all experience entries",
        };
      }
      if (hasTechError) {
        errors.tech = {
          status: true,
          msg: "Technology is required for all experience entries",
        };
      }
    }

    if (!selectedSkills || selectedSkills.length === 0) {
      errors.skills = {
        status: true,
        msg: "At least one skill must be selected",
      };
    }

    if (!employeeData.qualification || !employeeData.qualification.trim()) {
      errors.qualification = {
        status: true,
        msg: "Degree/qualification is required",
      };
    }

    if (!employeeData.college || !employeeData.college.trim()) {
      errors.college = { status: true, msg: "College name is required" };
    }

    if (!employeeData.collegeCity || !employeeData.collegeCity.trim()) {
      errors.collegeCity = { status: true, msg: "City is required" };
    }

    if (!employeeData.nationality) {
      errors.nationality = { status: true, msg: "Nationality is required" };
    }

    if (!employeeData.religion) {
      errors.religion = { status: true, msg: "Religion is required" };
    }

    if (!employeeData.projects || employeeData.projects.length === 0) {
      errors.projects = {
        status: true,
        msg: "At least one project is required",
      };
    }

    if (!employeeData.otherInfo || !employeeData.otherInfo.trim()) {
      errors.otherInfo = {
        status: true,
        msg: "Soft skills and other programming interests are required",
      };
    }

    if (!employeeData.profilePic) {
      errors.profilePic = { status: true, msg: "Profile picture is required" };
    }

    if (Object.keys(errors).length > 0) {
      setValidations(errors);
      return false;
    }

    return true;
  };

  // console.log(
  //   "📢[Create.js:306]: profile picture  ",
  //   employeeData.profilePic
  //     ? employeeData.profilePic?.startsWith("data:")
  //       ? employeeData.profilePic
  //       : `${process.env.REACT_APP_IMAGE_URL}images/employee/profile_pic/${employeeData.profilePic}`
  //     : "",
  // );
  // validation functions
  const validateTotalExperience = (data, index) => {
    let totalTotal = parseFloat(data.experience) || 0;
    let total = parseFloat(data.experienceDetails[index]?.duration) || 0;
    console.log(total, "total");
    if (total > totalTotal) {
      setTotalExperienceValidation({
        status: true,
        msg: "Individual experiences is not grater then Total Experience ",
      });
      setTimeout(() => {
        setTotalExperienceValidation({ status: false, msg: "" });
      }, 7000);
      return false;
    }
    if (totalExperienceValidation.status) {
      setTotalExperienceValidation({ status: false, msg: "" });
    }
    return true;
  };

  // other functions
  const processTime = (time) => {
    const hours = time.split(":")[0];
    const minutes = time.split(":")[1];
    return new Date(new Date(new Date().setHours(hours)).setMinutes(minutes));
  };

  const formatProfileData = (data) => {
    // const profilePicResult = await axios.get("/employee-profile/get-employee-profile-pic", {
    //   params: data._id,
    // });

    console.log("data", data);
    if (data) {
      setSelectedSkills([...data.skills]);
      const empData = {
        company: data.company?._id,
        name: data.name,
        expertise: [data.expertise?._id],
        summary: data.summary,
        timeFrom: processTime(data.timeFrom),
        timeTill: processTime(data.timeTill),
        experience: data.experience,
        experienceDetails: data.experienceDetails,
        tools: data.tools,
        languages: data.languages.map((lang) => ({
          name: lang?.name || null,
          value: lang?.value || null,
          id: lang.id || lang._id,
        })),
        // languages: data.languages.map((lang) => {
        //   const match = languageOptions.filter(
        //     (opt) => opt?.id === lang?.name
        //   )[0];

        //   return { value: lang.value, name: match?.name, id: match?.id };
        // }),
        qualification: data.qualification,
        graduationDate: new Date(data.graduationDate),
        college: data.college,
        collegeCity: data.collegeCity,
        nationality: data.nationality?._id,
        religion: data.religion?._id,
        projects: data.projects,
        otherInfo: data.otherInfo,
        profilePic: data.profile_pic,
        timeZone: data.timeZone || "",
        location: data.location || "",
        availability: data.availability || "",
        id: data._id,
        template: data.template || "",
        primaryColor: data.primaryColor || "",
        secondaryColor: data.secondaryColor || "",
      };
      // restore template+color selectors (use defaults from templateData when not explicitly saved)
      const tplKey = data.template || data.templateData?.key || "";
      const pColor =
        data.primaryColor || data.templateData?.defaultPrimaryColor || "";
      const sColor =
        data.secondaryColor || data.templateData?.defaultSecondaryColor || "";
      if (tplKey) setSelectedTemplate(tplKey);
      if (pColor) setPrimaryColor(pColor);
      if (sColor) setSecondaryColor(sColor);
      setEmployeeData((prevState) => ({ ...prevState, ...empData }));
      markFormAsSaved({ ...employeeData, ...empData }, [...data.skills]);

      // Directly pass to language fetch
      // fetchLanguageOptions(data.languages, data.company?._id);
    }

    // Slight delay to make sure state updates first
    setTimeout(() => {
      if (data.company?._id) {
        fetchLanguageOptions(data.languages, data.company?._id);
      } else {
        fetchLanguageOptions(data.languages);
      }
    }, 0);

    if (data.profile_pic) {
      console.log("Loaded Profile Pic:", data.profile_pic);
      console.log(
        "Full Profile Pic URL:",
        `${process.env.REACT_APP_IMAGE_URL}images/employee/profile_pic/${data.profile_pic}`,
      );
    }
  };

  useEffect(() => {
    if (!id || (id && employeeData.company)) {
      if (!id) {
        fetchLanguageOptions(); // only on create flow
      }
      fetchExpertiseOptions();
      fetchNationalityOptions();
      fetchReligionOptions();
      fetchToolsList();
    }
  }, [employeeData.company]);

  useEffect(() => {
    if (skipDirtyTrackingRef.current) return;
    setHasUnsavedChanges(
      buildFormSnapshot() !== initialFormSnapshotRef.current,
    );
  }, [employeeData, selectedSkills]);

  useEffect(() => {
    if (id) return;
    if (!skipDirtyTrackingRef.current) return;

    const timer = setTimeout(() => {
      markFormAsSaved();
    }, 0);

    return () => clearTimeout(timer);
  }, [id]);

  useEffect(() => {
    const confirmationMessage =
      "You have unsaved changes. Are you sure you want to leave this page?";

    const handleBeforeUnload = (event) => {
      if (skipConfirmNavigationRef.current || !hasUnsavedChanges) return;
      event.preventDefault();
      event.returnValue = "";
    };

    const confirmNavigation = () =>
      skipConfirmNavigationRef.current ||
      !hasUnsavedChanges ||
      window.confirm(confirmationMessage);

    const originalPushState = window.history.pushState.bind(window.history);
    const originalReplaceState = window.history.replaceState.bind(
      window.history,
    );

    window.history.pushState = (...args) => {
      if (confirmNavigation()) {
        originalPushState(...args);
      }
    };

    window.history.replaceState = (...args) => {
      if (confirmNavigation()) {
        originalReplaceState(...args);
      }
    };

    const handlePopState = () => {
      if (!confirmNavigation()) {
        window.history.go(1);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, [hasUnsavedChanges]);

  const handleSelectFieldChange = (value, field) => {
    setEmployeeData((prevState) => ({
      ...prevState,
      [`${field}`]: value,
    }));
  };

  const handleTextFieldChange = (value, field) => {
    setEmployeeData((prevState) => ({
      ...prevState,
      [`${field}`]: value,
    }));
  };

  const handleSkillToggle = (skill) => {
    const tempSkillArr = [...selectedSkills];
    if (selectedSkills.includes(skill)) {
      const index = selectedSkills.indexOf(skill);
      tempSkillArr.splice(index, 1);
      if (tempSkillArr.length) {
        resetValidationField("skill");
      }
      setSelectedSkills(tempSkillArr);
      return;
    }
    tempSkillArr.push(skill);
    if (tempSkillArr.length) {
      resetValidationField("skills");
    }
    setSelectedSkills(tempSkillArr);
  };

  const handleDelete = (index) => {
    setEmployeeData((prevState) => {
      const updatedDetails = prevState.experienceDetails.filter(
        (_, i) => i !== index,
      );
      return { ...prevState, experienceDetails: updatedDetails };
    });
  };

  const handleAddEdit = (field, operation) => {
    switch (field) {
      case "expertise":
        if (operation === "edit") {
          setModalStatus({ ...modalStatus, editExpertise: true });
        }
        if (operation === "add") {
          setModalStatus({ ...modalStatus, addExpertise: true });
        }
        return;
      case "experience":
        if (operation === "edit") {
          setModalStatus({ ...modalStatus, editExperience: true });
        }
        if (operation === "add") {
          setModalStatus({ ...modalStatus, addExperience: true });
        }
        return;
      case "tools":
        if (operation === "edit") {
          setModalStatus({ ...modalStatus, editTools: true });
        }
        if (operation === "add") {
          setModalStatus({ ...modalStatus, addTool: true });
        }
        return;
      case "language":
        if (operation === "edit") {
          setModalStatus({ ...modalStatus, editLanguages: true });
        }
        if (operation === "add") {
          setModalStatus({ ...modalStatus, addLanguage: true });
        }
        return;
      case "N/R":
        if (operation === "add") {
          setModalStatus({ ...modalStatus, addNR: true });
        }
        return;
      case "project":
        if (operation === "edit") {
          setModalStatus({ ...modalStatus, editProjects: true });
        }
        if (operation === "add") {
          setModalStatus({ ...modalStatus, addProject: true });
        }
        return;
      default:
        return;
    }
  };

  const AddEditIcons = (props) => (
    <Box style={{ display: "flex", alignItems: "center", gap: "4px" }}>
      <IconButton
        size="small"
        onClick={() => handleAddEdit(props.for, "add")}
        sx={{ paddingTop: "0px" }}
      >
        <AddCircleOutline color="primary" />
      </IconButton>
      {props.for !== "project" && (
        <IconButton
          size="small"
          onClick={() => handleAddEdit(props.for, "edit")}
          sx={{ paddingTop: "0px" }}
        >
          <Edit color="primary" />
        </IconButton>
      )}
    </Box>
  );

  const processDurationString = (years, months) => {
    let str = "";
    if (years) {
      if (years === 1) {
        str += `${years} Year`;
      } else {
        str += `${years} Years`;
      }
    }
    if (months) {
      if (months === 1) {
        str += ` ${months} Month`;
      } else {
        str += ` ${months} Months`;
      }
    }
    return str;
  };

  const resetValidationField = (field) => {
    setValidations((prevState) => ({
      ...prevState,
      [`${field}`]: {
        status: false,
        msg: "",
      },
    }));
  };

  // API Services
  const saveEmployeeProfile = () => {
    if (!validateForm()) return;

    const body = {
      ...employeeData,
      experience: employeeData.experience ? Number(employeeData.experience) : 0,
      experienceDetails: (employeeData.experienceDetails || []).map((exp) => ({
        ...exp,
        duration: exp.duration ? Number(exp.duration) : 0,
      })),
      projects: (employeeData.projects || []).map((project) => ({
        ...project,
        toolsAndTechnology: Array.isArray(project.toolsAndTechnology)
          ? project.toolsAndTechnology
          : typeof project.toolsAndTechnology === "string" &&
              project.toolsAndTechnology.trim() !== ""
            ? project.toolsAndTechnology
                .split(",")
                .map((t) => t.trim())
                .filter((t) => t)
            : [],
      })),
      timeFrom: !isNaN(employeeData.timeFrom.getTime())
        ? `${employeeData.timeFrom.getHours()}:${employeeData.timeFrom.getMinutes()}`
        : "",
      timeTill: !isNaN(employeeData.timeTill.getTime())
        ? `${employeeData.timeTill.getHours()}:${employeeData.timeTill.getMinutes()}`
        : "",
      skills: selectedSkills,
      timeZone: employeeData.timeZone,
      location: employeeData.location,
      availability: employeeData.availability,
      graduationDate: formatDateYMD(employeeData.graduationDate),
      languages: employeeData.languages.map((lang) => ({
        id: lang.id,
        value: lang.value,
      })),
      createdBy: userData.id,
      template: selectedTemplate,
      primaryColor: primaryColor || undefined,
      secondaryColor: secondaryColor || undefined,
    };

    if (!body.timeFrom || !body.timeTill) {
      return;
    }

    // if is created by admin need to assign the profile to that admin
    body.assignedToAdmins = [...(body.assignedToAdmins || []), userData.id];

    axios
      .post("employee-profile/create", body)
      .then((res) => {
        if (res.status === 200) {
          if (!res.data.status && res.data.type === "validation") {
            const val = {};
            const messages = [];
            res.data.error.forEach((err) => {
              let msg = "Required";
              if (err.field === "backendExpVal") {
                msg = err.message;
              }
              if (err.field === "profilePicUploadErr") {
                msg = err.message;
              }
              val[err.field] = { status: true, msg };
              messages.push(err.message || `${err.field} is invalid`);
            });
            setValidations({ ...val });
            displayAlertMessage(
              "error",
              "Validation failed: " + messages.join(", "),
            );
          }
          if (res.data.status) {
            skipConfirmNavigationRef.current = true;
            markFormAsSaved(body, selectedSkills);
            setSuccessMsg(true);
            setValidations({});
            navigate("/employee-profiles/list");
          }
        }
      })
      .catch((err) => {
        console.log(err);
        displayAlertMessage("error", "Something went wrong. Please try again.");
      });
  };

  const updateEmployeeProfile = () => {
    if (!validateForm()) return;

    const params = { id: employeeData.id };

    const body = {
      ...employeeData,
      experience: employeeData.experience ? Number(employeeData.experience) : 0,
      experienceDetails: (employeeData.experienceDetails || []).map((exp) => ({
        ...exp,
        duration: exp.duration ? Number(exp.duration) : 0,
      })),
      timeFrom: !isNaN(employeeData.timeFrom.getTime())
        ? `${employeeData.timeFrom.getHours()}:${employeeData.timeFrom.getMinutes()}`
        : "",
      timeTill: !isNaN(employeeData.timeTill.getTime())
        ? `${employeeData.timeTill.getHours()}:${employeeData.timeTill.getMinutes()}`
        : "",
      skills: selectedSkills,
      timeZone: employeeData.timeZone,
      location: employeeData.location,
      availability: employeeData.availability,
      graduationDate: employeeData.graduationDate,
      languages: employeeData.languages.map((lang) => ({
        id: lang.id,
        value: lang.value,
      })),
      template: selectedTemplate,
      primaryColor: primaryColor || undefined,
      secondaryColor: secondaryColor || undefined,
    };

    delete body.id;

    if (!body.timeFrom || !body.timeTill) {
      return;
    }

    console.log("Updating Employee Profile. Payload:", body);

    axios
      .put("employee-profile/update", body, { params })
      .then((res) => {
        if (res.status === 200) {
          if (!res.data.status && res.data.type === "validation") {
            const val = {};
            const messages = [];
            res.data.error.forEach((err) => {
              let msg = "Required";
              if (err.field === "backendExpVal") {
                msg = err.message;
              }
              if (err.field === "profilePicUploadErr") {
                msg = err.message;
              }
              val[err.field] = { status: true, msg };
              messages.push(err.message || `${err.field} is invalid`);
            });
            setValidations({ ...val });
            displayAlertMessage(
              "error",
              "Validation failed: " + messages.join(", "),
            );
          }
          if (res.data.status) {
            console.log("Update Success. Response Data:", res.data.data);
            if (res.data.data?.profile_pic) {
              console.log("Profile Pic Updated As:", res.data.data.profile_pic);
              console.log(
                "New Full Profile Pic URL:",
                `${process.env.REACT_APP_IMAGE_URL}images/employee/profile_pic/${res.data.data.profile_pic}`,
              );
            }
            skipConfirmNavigationRef.current = true;
            markFormAsSaved({ ...employeeData, ...body }, selectedSkills);
            setUpdateMsg(true);
            setValidations({});
            navigate("/employee-profiles/list");
            // getEmployeeProfile();
          }
        }
      })
      .catch((err) => {
        console.log(err);
        displayAlertMessage("error", "Something went wrong. Please try again.");
      });
  };

  const displayAlertMessage = (variant, message) => {
    setDisplayAlert(true);
    setAlertMessage(message);
    setAlertVariant(variant);
  };

  const closeAlertMessage = () => {
    setDisplayAlert(false);
    setAlertMessage("");
  };

  // ── Project drag-and-drop reorder ─────────────────────────────────────
  const onDragEnd = (result) => {
    if (!result.destination) return;
    if (result.destination.index === result.source.index) return;
    setEmployeeData((prevState) => {
      const reordered = Array.from(prevState.projects || []);
      const [removed] = reordered.splice(result.source.index, 1);
      reordered.splice(result.destination.index, 0, removed);
      return { ...prevState, projects: reordered };
    });
  };

  // ── Show / hide project in resume ──────────────────────────────────────
  const toggleProjectVisibility = (index) => {
    setEmployeeData((prevState) => {
      const updated = [...(prevState.projects || [])];
      updated[index] = {
        ...updated[index],
        showInResume: updated[index].showInResume === false ? true : false,
      };
      return { ...prevState, projects: updated };
    });
  };

  const generatePreview = () => {
    setGeneratingPreview(true);

    const body = {
      ...employeeData,
      company: employeeData.company || "",
      name: employeeData.name || "",
      timeFrom: `${employeeData.timeFrom.getHours()}:${employeeData.timeFrom.getMinutes()}`,
      timeTill: `${employeeData.timeTill.getHours()}:${employeeData.timeTill.getMinutes()}`,
      skills: selectedSkills,
      timeZone: employeeData.timeZone,
      location: employeeData.location,
      availability: employeeData.availability,
      graduationDate: formatDateYMD(employeeData.graduationDate),
      languages: employeeData.languages.map((lang) => ({
        value: lang.value,
        name: lang.name,
      })),
      // Template & color customization
      template: selectedTemplate,
      primaryColor: primaryColor || undefined,
      secondaryColor: secondaryColor || undefined,
    };

    delete body.id;

    axios
      .post("admin/employee_profile/generate_preview", body, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        // eslint-disable-next-line
        if (res.headers["content-type"] == "application/pdf") {
          // display pdf preview
          let blob = new Blob([res.data], {
            type: res.headers["content-type"],
          });
          setPreviewSourcePath(URL.createObjectURL(blob));
          setProfilePreviewDialog(true);
        } else {
          // handle error
          try {
            let response = JSON.parse(
              String.fromCharCode.apply(null, new Uint8Array(res.data)),
            );

            if (!response.status) {
              displayAlertMessage("error", "Something went wrong");
            }
          } catch (error) {
            displayAlertMessage("error", "Something went wrong");
          }
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setGeneratingPreview(false);
      });
  };

  const fetchLanguageOptions = (initialLanguages = [], companyId) => {
    console.log(
      "fetchLanguageOptions calls : ",
      initialLanguages,
      "companyId : ",
      companyId,
    );
    // const role = getUserData().role;

    // const query = role == "SuperAdmin" ? { company: companyId ?? employeeData.company } : {};

    const role = getUserData().role;

    // Use passed companyId param, fallback to employeeData.company
    const resolvedCompanyId = companyId ?? employeeData.company;
    const query = role == "SuperAdmin" ? { company: resolvedCompanyId } : {};

    axios
      .get("admin/all-languages", { params: query })
      .then((res) => {
        if (res.status === 200) {
          const all = res.data.data || [];

          // Filter disabled ones
          const enabledOptions = all
            .filter((opt) => !opt.is_disabled)
            .map((opt) => ({ name: opt.name, id: opt._id }));

          // Set both all options and enabled-only options
          const filteredOptions = all.map((opt) => ({
            name: opt.name,
            id: opt._id,
          }));

          setLanguageOptions(filteredOptions);
          setEnableLanguageOptions(enabledOptions);

          console.log("employeeData.languages", employeeData.languages);

          console.log("initialLanguages", initialLanguages);

          setEmployeeData((prevState) => {
            let initlang;
            if (
              initialLanguages.length === 0 &&
              prevState.languages?.length === 0
            ) {
              initlang = [{ name: all[0]?.name, id: all[0]?._id, value: 3 }];
            } else if (initialLanguages.length > 0) {
              initlang = initialLanguages.map((lang) => {
                const match = filteredOptions.find(
                  (opt) =>
                    opt.id?.toString() === lang.id?.toString() ||
                    opt.id?.toString() === lang._id?.toString() ||
                    opt.id?.toString() === lang.name?.toString(), // stored as _id
                );
                return {
                  value: lang.value,
                  name: match?.name || lang.name,
                  id: match?.id || lang.id || lang._id,
                };
              });
            } else {
              initlang = prevState.languages; // use prevState, not employeeData
            }
            return { ...prevState, languages: initlang };
          });
          // setEmployeeData((prevState) => {
          //   let initlang;

          //   if (initialLanguages.length == 0 && employeeData?.languages?.length == 0) {
          //     initlang = [
          //       {
          //         name: res.data.data[0]?.name,
          //         id: res.data.data[0]?._id,
          //         value: 3,
          //       },
          //     ];
          //   } else {
          //     if (initialLanguages.length > 0) {
          //       initlang = initialLanguages.map((lang) => {
          //         // lang.name could be either an _id string OR an actual name depending on data source
          //         // Match against both id and name fields
          //         const match = filteredOptions.find(
          //           (opt) =>
          //             opt?.id?.toString() === lang?.name?.toString() || // stored as _id in name field
          //             opt?.id?.toString() === lang?._id?.toString() || // has _id directly
          //             opt?.name === lang?.name, // already has real name
          //         );

          //         return {
          //           value: lang.value,
          //           name: match?.name || lang.name,
          //           id: match?.id || lang.id || lang._id,
          //         };
          //       });
          //     } else {
          //       initlang = employeeData.languages;
          //     }
          //     // if (initialLanguages.length > 0) {
          //     //   initlang = initialLanguages.map((lang) => {
          //     //     const match = filteredOptions.filter(
          //     //       (opt) => opt?.id.toString() === lang?.name.toString()
          //     //     )[0];

          //     //     return { value: lang.value, name: match?.name, id: match?.id };
          //     //   });
          //   }
          //   return {
          //     ...prevState,
          //     languages: initlang,
          //   };
          // });
        }
      })
      .catch((err) => console.log(err));
  };

  console.log("employee data languages ", employeeData.languages);

  const fetchReligionOptions = () => {
    const query =
      getUserData().role == "SuperAdmin"
        ? { company: employeeData.company }
        : {};
    axios
      .get("/admin/all-religions", { params: query })
      .then((res) => {
        if (res.status === 200) {
          const allReligionOptions = res.data.result;

          // Filter disabled ones
          const enabledOptions = allReligionOptions
            .filter((opt) => !opt.is_disabled)
            .map((opt) => ({ name: opt.name, id: opt._id }));

          // Set both all options and enabled-only options
          const allOptions = allReligionOptions.map((opt) => ({
            name: opt.name,
            id: opt._id,
          }));

          setReligionOptions(allOptions);
          setEnableReligions(enabledOptions);
        }
      })
      .catch((err) => console.log(err));
  };

  const fetchToolsList = async () => {
    abortController.current.abort();
    abortController.current = new AbortController();
    try {
      const data = await axios.get("/admin/tools/all", {
        params: {
          company: employeeData.company,
        },
        signal: abortController.current.signal,
      });

      const resData = data.data;
      if (resData.status) {
        if (Array.isArray(resData.data)) {
          setToolsList(resData.data);
        }
      }
    } catch (err) {}
  };

  const fetchExpertiseOptions = () => {
    const query =
      getUserData().role == "SuperAdmin"
        ? { company: employeeData.company }
        : {};

    axios
      .get("/admin/all-expertise", { params: query })
      .then((res) => {
        if (res.status === 200) {
          const allExpertise = res.data.result;
          let expertise = [];
          let enabledExpertise = [];

          let skillOptions = {};

          allExpertise
            .filter((exp) => !exp.is_disabled)
            .forEach((exp) => {
              enabledExpertise.push({ name: exp?.name, id: exp?._id });
              // skillOptions[exp._id] = exp.skills;
            });

          allExpertise?.forEach((exp) => {
            // populate expertise options
            expertise.push({ name: exp?.name, id: exp?._id });
            // populate skills options
            skillOptions[exp._id] = exp.skills;
          });

          setExpertiseOptions(expertise);
          setEnabledExpertiseOptions(enabledExpertise);
          setSkillOptions(skillOptions);
          // take first expertise as default to resolve input render issue

          if (!id) {
            setEmployeeData((prevState) => {
              return {
                ...prevState,
                expertise: [],
              };
            });
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const fetchCompanyOptions = () => {
    axios
      .get("/admin/all-companies")
      .then((res) => {
        if (res.status === 200) {
          setCompanyOptions(
            res.data.data.map((cmp) => ({ name: cmp.name, id: cmp.id })),
          );
        }
      })
      .catch((err) => console.log(err));
  };

  const fetchNationalityOptions = () => {
    const query =
      getUserData().role == "SuperAdmin"
        ? { company: employeeData.company }
        : {};

    axios
      .get("/admin/all-nationalities", { params: query })
      .then((res) => {
        if (res.status === 200) {
          const allNationalityOptions = res.data.result;

          // Filter disabled ones
          const enabledOptions = allNationalityOptions
            .filter((opt) => !opt.is_disabled)
            .map((opt) => ({ name: opt.name, id: opt._id }));

          // Set both all options and enabled-only options
          const allOptions = allNationalityOptions.map((opt) => ({
            name: opt.name,
            id: opt._id,
          }));

          setNationalityOptions(allOptions);
          setEnabledNaitonality(enabledOptions);
        }
      })
      .catch((err) => console.log(err));
  };

  const getEmployeeProfile = (id) => {
    axios
      .get("/employee-profile/get-employee-profile", { params: { id } })
      .then((res) => {
        if (res.status === 200 && res.data.status) {
          formatProfileData(res.data.data);
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getEmployeeProfile(id);
    fetchCompanyOptions();

    return () => {
      abortController.current.abort();
    };
  }, []);
  // fetchNationalityOptions();
  // fetchExpertiseOptions();
  // fetchReligionOptions();
  // fetchLanguageOptions();
  // fetchToolsList();

  // useEffect(() => {
  //   if (languageOptions.length) {
  //     if (id) {
  //       getEmployeeProfile(id);
  //     }
  //   }
  // // eslint-disable-next-line
  // }, [languageOptions]);

  useEffect(() => {
    let companyId =
      getUserData().role == "Company" ||
      getUserData().role == "CompanyAdmin" ||
      getUserData().role == "Admin"
        ? getUserData().company_id
        : "";

    setCompanyId(companyId);
    companyId && handleSelectFieldChange(companyId, "company");
  }, [companyOptions]);

  return (
    <>
      <Box style={{ marginBottom: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Box>
          <Typography variant="h6" style={{ color: "#474747", fontWeight: 600, margin: 0 }}>
            {id ? "Edit" : "Create New"} Profile
          </Typography>
          <Typography variant="body2" style={{ color: "#6b7280", marginTop: "2px" }}>
            Fields are grouped into sections — click a section header to expand it.
          </Typography>
        </Box>
        <Button variant="outlined" size="small" onClick={() => navigate("/employee-profiles/list")}>
          Back
        </Button>
      </Box>

      <div className="layout" style={{ alignItems: "flex-start" }}>
        {/* ── SIDEBAR ── */}
        <div className="sidebar">
          <div className="sidebar-label">Sections</div>

          {[
            { id: 'sec-basic', label: 'Basic info',
              icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/></svg> },
            { id: 'sec-availability', label: 'Location & availability',
              icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg> },
            { id: 'sec-skills', label: 'Skills & expertise',
              icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zm-7 9.17L12 17l7-4.83V17.5l-7 3.75-7-3.75v-5.33z"/></svg> },
            { id: 'sec-education', label: 'Education',
              icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/></svg> },
            { id: 'sec-projects', label: 'Projects & extras',
              icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M20 6h-4V4c0-1.1-.9-2-2-2h-4C8.9 2 8 2.9 8 4v2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-8-2h4v2h-4V4z"/></svg> },
            { id: 'sec-template', label: 'Template & style',
              icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M4 5v13h16V5H4zm7 11H6v-2h5v2zm0-4H6v-2h5v2zm0-4H6V6h5v2zm7 8h-5v-8h5v8z"/></svg> },
          ].map(({ id: secId, label, icon }) => (
            <div
              key={secId}
              className={`nav-item ${activeSections.includes(secId) ? 'active' : ''}`}
              onClick={() => handleSectionClick(secId)}
            >
              <div className="section-icon" style={{ width: '24px', height: '24px' }}>
                {icon}
              </div>
              {label}
            </div>
          ))}
        </div>

        {/* ── MAIN CONTENT ── */}
        <div className="main">

          {/* ══ SECTION 1: BASIC INFO ══ */}
          <div className={`section ${activeSections.includes('sec-basic') ? 'open' : ''}`} id="sec-basic">
            <div className="section-head" onClick={() => handleSectionClick('sec-basic')}>
              <div className="left">
                <div className="section-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/></svg>
                </div>
                <div>
                  <div className="section-title">Basic info</div>
                  <div className="section-desc">Company, name, designation, photo, and summary</div>
                </div>
              </div>
              <div className="chevron">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M7 10l5 5 5-5z"/></svg>
              </div>
            </div>
            <div className="section-body">

              {/* Photo */}
              <div className="row">
                <div className="photo-block" style={{ flex: "0 0 120px" }}>
                  <FormLabel title="Photo" />
                  <Avatar
                    src={
                      employeeData.profilePic
                        ? employeeData.profilePic?.startsWith("data:")
                          ? employeeData.profilePic
                          : `${process.env.REACT_APP_IMAGE_URL}images/employee/profile_pic/${employeeData.profilePic}`
                        : ""
                    }
                    style={{ height: "80px", width: "80px", margin: "0 auto" }}
                  />
                  <input
                    id="profile-pic"
                    type="file"
                    accept="image/jpeg, image/png, image/jpg"
                    hidden
                    onChange={(e) => {
                      if (e.target.files.length) {
                        const file = e.target.files[0];
                        const fileExtension = file.name.split(".").pop().toLowerCase();
                        const validExtensions = ["jpg", "jpeg", "png"];
                        if (validExtensions.includes(fileExtension)) {
                          const reader = new FileReader();
                          reader.readAsDataURL(file);
                          reader.onload = () => {
                            resetValidationField("profilePic");
                            setEmployeeData((prevState) => ({ ...prevState, profilePic: reader.result }));
                          };
                          reader.onerror = (error) => console.log(error);
                        } else {
                          alert("Invalid file type. Please upload .jpg, .jpeg, or .png");
                        }
                      }
                    }}
                  />
                  <div className="btn-row" style={{ justifyContent: "center", marginTop: "10px" }}>
                    <Button size="small" variant="contained"
                      onClick={() => document.getElementById("profile-pic").click()}
                    >
                      {employeeData.profilePic?.length ? "Edit" : "Add"}
                    </Button>
                    <Button size="small" variant="outlined"
                      onClick={() => {
                        setEmployeeData((prevState) => { delete prevState.profilePic; return { ...prevState }; });
                        document.getElementById("profile-pic").value = "";
                      }}
                    >
                      Delete
                    </Button>
                  </div>
                  {validations.profilePic?.status && <Alert severity="error" style={{ fontSize: "11px", padding: "2px 8px" }}>{validations.profilePic?.msg}</Alert>}
                </div>
              </div>

              {/* Company + Name + Designation */}
              <div className="row" style={{ gap: "14px", flexWrap: "wrap", marginTop: "16px" }}>
                  {/* Company */}
                  <div className="field">
                    <Box style={{ display: "flex", alignItems: "flex-end", minHeight: "48px" }}>
                      <FormLabel title="Company Name" required sx={{ marginBottom: 0 }} />
                    </Box>
                    <FormControl error={validations.company?.status} style={{ width: "100%" }}>
                      <Select
                        size="small"
                        MenuProps={{ PaperProps: { style: { maxHeight: 250 } } }}
                        onChange={(e) => {
                          handleSelectFieldChange(e.target.value, "company");
                          if (validations.company?.status) resetValidationField("company");
                        }}
                        disabled={companyId || false}
                        value={employeeData.company}
                        displayEmpty={true}
                        renderValue={() => {
                          const styles = {};
                          const value = employeeData.company
                            ? companyOptions.filter((opt) => opt.id === employeeData.company)[0]?.name
                            : "Select";
                          if (value === "Select") styles.color = "#919fa5";
                          return <div style={styles}>{value}</div>;
                        }}
                      >
                        {companyOptions.map((cmp) => <MenuItem key={cmp.id} value={cmp.id}>{cmp.name}</MenuItem>)}
                      </Select>
                      {validations.company?.status && <FormHelperText>{validations.company?.msg}</FormHelperText>}
                    </FormControl>
                  </div>

                  {/* Employee Name */}
                  <div className="field">
                    <Box style={{ display: "flex", alignItems: "flex-end", minHeight: "48px" }}>
                      <FormLabel title="Employee Name" required hint="max 20 chars" sx={{ marginBottom: 0 }} />
                    </Box>
                    <TextField
                      id="name" key="name" size="small"
                      placeholder="e.g. John Smith"
                      style={{ width: "100%" }}
                      inputProps={{ maxLength: 20 }}
                      error={validations.name?.status || false}
                      helperText={validations.name?.msg || `${(employeeData.name || "").length}/20`}
                      value={employeeData.name || ""}
                      onChange={(e) => {
                        handleTextFieldChange(e.target.value, "name");
                        if (validations.name?.status) resetValidationField("name");
                      }}
                    />
                  </div>

                  {/* Current Designation */}
                  <div className="field">
                    <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", minHeight: "48px" }}>
                      <FormLabel title="Current Designation" required sx={{ marginBottom: 0 }} />
                      <AddEditIcons for="expertise" />
                    </Box>
                    {(employeeData.expertise?.length ? employeeData.expertise : [""]).map((exp, index) => (
                      <Box key={index} style={{ marginBottom: "5px" }}>
                        <FormControl style={{ width: "100%" }} error={validations.expertise?.status && !exp}>
                          <Select
                            size="small" style={{ width: "100%" }}
                            value={exp || ""} displayEmpty
                            MenuProps={{ PaperProps: { style: { maxHeight: 250 } } }}
                            onChange={(e) =>
                              setEmployeeData((prevState) => {
                                const tempData = [...(prevState.expertise || [""])];
                                tempData[index] = e.target.value;
                                setSelectedSkills([]);
                                return { ...prevState, expertise: tempData };
                              })
                            }
                            renderValue={(selected) => {
                              if (!selected) return <span style={{ color: "#919fa5" }}>Select</span>;
                              return enabledExpertiseOptions.find((opt) => opt.id === selected)?.name;
                            }}
                          >
                            <MenuItem value=""><em>Select</em></MenuItem>
                            {enabledExpertiseOptions.map((opt) => (
                              <MenuItem key={opt.id} value={opt.id}>{opt.name}</MenuItem>
                            ))}
                          </Select>
                          {validations.expertise?.status && !exp && (
                            <FormHelperText>{validations.expertise?.msg}</FormHelperText>
                          )}
                        </FormControl>
                      </Box>
                    ))}
                  </div>
              </div>

              {/* Profile Summary */}
              <div className="row">
                <div className="field">
                  <FormLabel title="Profile Summary" required hint="max 1000 chars" />
                  <TextareaAutosize
                    className={validations.summary?.status ? "mui-textarea-error" : "mui-textarea"}
                    placeholder="Briefly describe the employee's background, key skills, and career highlights..."
                    minRows={5} maxLength={1000}
                    style={{ width: "100%", padding: "10px" }}
                    value={employeeData.summary || ""}
                    onChange={(e) => {
                      handleTextFieldChange(e.target.value, "summary");
                      if (validations.summary?.status) resetValidationField("summary");
                    }}
                  />
                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: "2px" }}>
                    {validations.summary?.status
                      ? <FormHelperText style={{ color: "#d32f2f", marginLeft: "15px", marginTop: 0 }}>{validations.summary?.msg}</FormHelperText>
                      : <span />}
                    <FormHelperText style={{ marginRight: "4px", marginTop: 0 }}>
                      {(employeeData.summary || "").length}/1000
                    </FormHelperText>
                  </div>
                </div>
              </div>

            </div>
          </div>

          {/* ══ SECTION 2: LOCATION & AVAILABILITY ══ */}
          <div className={`section ${activeSections.includes('sec-availability') ? 'open' : ''}`} id="sec-availability">
            <div className="section-head" onClick={() => handleSectionClick('sec-availability')}>
              <div className="left">
                <div className="section-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
                </div>
                <div>
                  <div className="section-title">Location &amp; availability</div>
                  <div className="section-desc">Timezone, working hours, status, location, and nationality</div>
                </div>
              </div>
              <div className="chevron"><svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M7 10l5 5 5-5z"/></svg></div>
            </div>
            <div className="section-body">

              {/* Availability subcard */}
              <div className="subcard">
                <div className="subcard-title">Availability</div>
                <div className="row" style={{ marginTop: 0 }}>
                  <div className="field">
                    <FormLabel title="Timezone" hint="e.g. EST/IST" />
                    <TextField
                      size="small" placeholder="EST/IST"
                      style={{ width: "100%" }}
                      inputProps={{ maxLength: 50 }}
                      value={employeeData.timeZone || ""}
                      onChange={(e) => handleTextFieldChange(e.target.value, "timeZone")}
                    />
                  </div>
                  <div className="field">
                    <FormLabel title="Start Time" required hint="HH:MM" />
                    <LocalizationProv dateAdapter={AdapterFns}>
                      <TimePicker
                        value={employeeData.timeFrom}
                        onChange={(value) => {
                          if (value && !isNaN(value.getTime())) {
                            setEmployeeData((prevState) => ({ ...prevState, timeFrom: value }));
                            if (validations.timeFrom?.status) resetValidationField("timeFrom");
                          }
                        }}
                        renderInput={(params) => (
                          <TextField size="small" {...params}
                            error={params.error || validations.timeFrom?.status}
                            helperText={params.error ? "Invalid format!" : validations.timeFrom?.msg || ""}
                            style={{ width: "100%" }}
                          />
                        )}
                      />
                    </LocalizationProv>
                  </div>
                  <div className="field">
                    <FormLabel title="End Time" required hint="HH:MM" />
                    <LocalizationProv dateAdapter={AdapterFns}>
                      <TimePicker
                        value={employeeData.timeTill}
                        onChange={(value) => {
                          if (value && !isNaN(value.getTime())) {
                            setEmployeeData((prevState) => ({ ...prevState, timeTill: value }));
                            if (validations.timeTill?.status) resetValidationField("timeTill");
                          }
                        }}
                        renderInput={(params) => (
                          <TextField size="small" {...params}
                            error={params.error || validations.timeTill?.status}
                            helperText={params.error ? "Invalid format!" : validations.timeTill?.msg || ""}
                            style={{ width: "100%" }}
                          />
                        )}
                      />
                    </LocalizationProv>
                  </div>
                  <div className="field">
                    <FormLabel title="Availability" />
                    <FormControl style={{ width: "100%" }}>
                      <Select
                        size="small"
                        value={employeeData.availability || ""}
                        onChange={(e) => handleSelectFieldChange(e.target.value, "availability")}
                        displayEmpty
                        renderValue={(val) => val || <span style={{ color: "#919fa5" }}>Select availability</span>}
                      >
                        <MenuItem value="Full time">Full time</MenuItem>
                        <MenuItem value="Part time">Part time</MenuItem>
                        <MenuItem value="Contract">Contract</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </div>

              {/* Location subcard */}
              <div className="subcard">
                <div className="subcard-title">Location</div>
                <div className="row" style={{ marginTop: 0 }}>
                  <div className="field">
                    <FormLabel title="Location" hint="e.g. Ahmedabad, Gujarat" />
                    <TextField
                      size="small" placeholder="Ahmedabad, Gujarat"
                      style={{ width: "100%" }}
                      inputProps={{ maxLength: 100 }}
                      value={employeeData.location || ""}
                      onChange={(e) => handleTextFieldChange(e.target.value, "location")}
                    />
                  </div>
                  <div className="field">
                    <FormLabel title="Nationality" required />
                    <FormControl error={validations.nationality?.status} style={{ width: "100%" }}>
                      <Select
                        size="small"
                        value={employeeData.nationality || ""}
                        onChange={(e) => {
                          handleSelectFieldChange(e.target.value, "nationality");
                          if (validations.nationality?.status) resetValidationField("nationality");
                        }}
                        displayEmpty={true}
                        renderValue={() => {
                          const styles = {};
                          let value = employeeData.nationality &&
                            nationalityOptions.filter((opt) => opt.id === employeeData.nationality)[0]?.name;
                          if (!value && employeeData.nationality) value = employeeData.nationality.name || "Select";
                          if (value === "Select" || !value) { styles.color = "#919fa5"; return <div style={styles}>Select</div>; }
                          return <div>{value}</div>;
                        }}
                      >
                        {enabledNationality.map((opt) => <MenuItem key={opt.id} value={opt.id}>{opt.name}</MenuItem>)}
                      </Select>
                      {validations.nationality?.status && <FormHelperText>{validations.nationality?.msg}</FormHelperText>}
                    </FormControl>
                  </div>
                  <div className="field">
                    <FormLabel title="Religion" required />
                    <FormControl error={validations.religion?.status} style={{ width: "100%" }}>
                      <Select
                        size="small" style={{ width: "100%" }}
                        value={employeeData.religion || ""}
                        onChange={(e) => {
                          handleSelectFieldChange(e.target.value, "religion");
                          if (validations.religion?.status) resetValidationField("religion");
                        }}
                        displayEmpty={true}
                        renderValue={() => {
                          const styles = {};
                          const value = employeeData.religion
                            ? religionOptions.filter((opt) => opt.id === employeeData.religion)[0]?.name
                            : "Select";
                          if (value === "Select") styles.color = "#919fa5";
                          return <div style={styles}>{value}</div>;
                        }}
                      >
                        {enableReligions.map((opt) => <MenuItem key={opt.id} value={opt.id}>{opt.name}</MenuItem>)}
                      </Select>
                      {validations.religion?.status && <FormHelperText>{validations.religion?.msg}</FormHelperText>}
                    </FormControl>
                  </div>
                  <Box sx={{ display: "flex", alignItems: "flex-end", pb: 0.5 }}>
                    <AddEditIcons for="N/R" />
                  </Box>
                </div>
              </div>

            </div>
          </div>

          {/* ══ SECTION 3: SKILLS & EXPERTISE ══ */}
          <div className={`section ${activeSections.includes('sec-skills') ? 'open' : ''}`} id="sec-skills">
            <div className="section-head" onClick={() => handleSectionClick('sec-skills')}>
              <div className="left">
                <div className="section-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zm-7 9.17L12 17l7-4.83V17.5l-7 3.75-7-3.75v-5.33z"/></svg>
                </div>
                <div>
                  <div className="section-title">Skills &amp; expertise</div>
                  <div className="section-desc">Experience, skills, tools, and languages</div>
                </div>
              </div>
              <div className="chevron"><svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M7 10l5 5 5-5z"/></svg></div>
            </div>
            <div className="section-body">

              {/* Total Exp + Experience by Expertise */}
              <div className="row">
                <div className="field">
                  <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <FormLabel title="Total Experience" required hint="years" />
                    <IconButton size="small" sx={{ paddingTop: "0px", visibility: "hidden" }}>
                      <AddCircleOutline color="primary" />
                    </IconButton>
                  </Box>
                  <div className="inline-row" style={{ marginBottom: "6px" }}>
                    <TextField
                      fullWidth
                      style={{ flex: 1 }}
                      size="small" type="number"
                      inputProps={{ step: "any" }}
                      placeholder="00 Years"
                      error={validations.experience?.status || false}
                      helperText={validations.experience?.msg || ""}
                      value={employeeData.experience}
                      onChange={(e) =>
                        setEmployeeData((prevState) => ({ ...prevState, experience: e.target.value }))
                      }
                    />
                  </div>
                </div>
                <div className="field">
                  <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <FormLabel title="Experience By Expertise" required hint="years per technology" />
                    <IconButton size="small"
                      onClick={() => setEmployeeData((prevState) => ({
                        ...prevState,
                        experienceDetails: [...prevState.experienceDetails, { duration: "", tech: "" }],
                      }))}
                      sx={{ paddingTop: "0px" }}
                    >
                      <AddCircleOutline color="primary" />
                    </IconButton>
                  </Box>
                  {Array.isArray(employeeData.experienceDetails) && employeeData.experienceDetails.map((data, index) => (
                    <div key={index} className="inline-row" style={{ marginBottom: "6px" }}>
                      <FormControl style={{ flex: 0.3 }} error={validations.duration?.status && !String(data.duration).length}>
                        <TextField
                          fullWidth
                          size="small" type="number"
                          inputProps={{ step: "any", min: "0" }}
                          placeholder="Years"
                          error={validations.duration?.status && !String(data.duration).length}
                          value={data.duration || ""}
                          onChange={(e) =>
                            setEmployeeData((prevState) => {
                              const tempData = [...prevState.experienceDetails] || [];
                              tempData[index] = { ...tempData[index], duration: e.target.value };
                              const tempState = { ...prevState, experienceDetails: [...tempData] };
                              if (!validateTotalExperience(tempState, index)) return { ...prevState };
                              return tempState;
                            })
                          }
                        />
                        {validations.duration?.status && !String(data.duration).length && (
                          <FormHelperText>{validations.duration?.msg}</FormHelperText>
                        )}
                      </FormControl>
                      <FormControl style={{ flex: 0.7, marginLeft: "5px" }} error={validations.tech?.status && !data.tech}>
                        <Select
                          size="small" value={data?.tech} displayEmpty={true}
                          MenuProps={{ PaperProps: { style: { maxHeight: 250 } } }}
                          onChange={(e) =>
                            setEmployeeData((prevState) => {
                              const tempState = prevState.experienceDetails;
                              tempState[index] = { ...tempState[index], tech: e.target.value };
                              return { ...prevState, experienceDetails: [...tempState] };
                            })
                          }
                          renderValue={() => {
                            const styles = {};
                            const value = data.tech ? data.tech : "Select technology";
                            if (value === "Select technology") styles.color = "#919fa5";
                            return <div style={styles}>{value}</div>;
                          }}
                        >
                          {enabledExpertiseOptions.map((opt) => <MenuItem key={opt.id} value={opt.name}>{opt.name}</MenuItem>)}
                        </Select>
                        {validations.tech?.status && !data.tech && <FormHelperText>{validations.tech?.msg}</FormHelperText>}
                      </FormControl>
                      {employeeData.experienceDetails.length > 1 && (
                        <IconButton size="small" onClick={() => handleDelete(index)}>
                          <Delete color="error" />
                        </IconButton>
                      )}
                    </div>
                  ))}
                  {totalExperienceValidation.status && <Alert severity="error">{totalExperienceValidation.msg}</Alert>}
                  {validations.backendExpVal?.status && <Alert severity="error">{validations.backendExpVal?.msg}</Alert>}
                </div>
              </div>

              {/* Skills subcard */}
              <div className="subcard">
                <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div className="subcard-title" style={{ margin: 0 }}>Skills <span style={{ color: "#d9534f" }}>*</span> (select at least one)</div>
                  <IconButton size="small"
                    onClick={() => setModalStatus((prevState) => ({ ...prevState, addEditSkill: true }))}
                    sx={{ paddingTop: "0px" }}
                  >
                    <Edit color="primary" />
                  </IconButton>
                </Box>
                <div className="chip-row">
                  {(() => {
                    const selectedExpIds = new Set();
                    if (employeeData.expertise && employeeData.expertise[0]) {
                      selectedExpIds.add(employeeData.expertise[0]);
                    }
                    if (Array.isArray(employeeData.experienceDetails)) {
                      employeeData.experienceDetails.forEach(exp => {
                        if (exp.tech) {
                          const opt = expertiseOptions.find(o => o.name === exp.tech);
                          if (opt) selectedExpIds.add(opt._id || opt.id);
                        }
                      });
                    }
                    const allSkills = Array.from(new Set(
                      Array.from(selectedExpIds).flatMap(id => skillOptions[id] || [])
                    ));
                    return allSkills.map((skill) => (
                      <Chip
                        key={skill}
                        color="primary"
                        variant={selectedSkills.includes(skill) ? "contained" : "outlined"}
                        label={skill}
                        style={{ margin: "4px" }}
                        onClick={() => handleSkillToggle(skill)}
                      />
                    ));
                  })()}
                </div>
                {validations.skills?.status && <Alert severity="error">{validations.skills?.msg}</Alert>}
              </div>

              {/* Tools + Languages */}
              <div className="row">
                <div className="field">
                  <div className="subcard">
                    <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div className="subcard-title" style={{ margin: 0 }}>Tools to handle project <span style={{ color: "var(--muted)", fontWeight: 400 }}>(add via + button)</span></div>
                      <AddEditIcons for="tools" />
                    </Box>
                    <Divider orientation="horizontal" style={{ margin: "6px 0" }} />
                    {employeeData.tools?.map((tool, index) => (
                      <Box style={{ paddingTop: "5px" }} key={`${tool.name}`}>
                        <Box style={{ display: "flex", justifyContent: "space-between" }}>
                          <Typography variant="body2">{tool?.name}</Typography>
                          <Typography variant="body2">{tool?.value}</Typography>
                        </Box>
                        <Slider
                          value={employeeData?.tools[index] ? employeeData?.tools[index].value : 0}
                          onChange={(e) => {
                            const tempData = employeeData?.tools;
                            if (employeeData?.tools.length) {
                              tempData[index] = { ...tempData[index], value: e.target.value };
                              setEmployeeData({ ...employeeData, tools: tempData });
                            }
                          }}
                        />
                      </Box>
                    ))}
                  </div>
                </div>
                <div className="field">
                  <div className="subcard">
                    <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div className="subcard-title" style={{ margin: 0 }}>Language <span style={{ color: "#d9534f" }}>*</span> (rate proficiency 1–5)</div>
                      <AddEditIcons for="language" />
                    </Box>
                    <Divider orientation="horizontal" style={{ margin: "6px 0" }} />
                    <Box style={{ paddingTop: "5px" }}>
                      {employeeData.languages?.map((lang, langIndex) => (
                        <Box key={langIndex} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
                          <Typography variant="body2">{lang.name}</Typography>
                          <StyledRating
                            precision={1}
                            icon={<Circle />}
                            emptyIcon={<CircleOutlined style={{ color: "#1497D4" }} />}
                            value={lang.value}
                            onChange={(e) => {
                              setEmployeeData((prevState) => {
                                const tempLangData = prevState?.languages;
                                tempLangData[langIndex] = { ...tempLangData[langIndex], value: parseInt(e.target.value) };
                                return { ...prevState, languages: [...tempLangData] };
                              });
                            }}
                          />
                        </Box>
                      ))}
                    </Box>
                  </div>
                </div>
              </div>

            </div>
          </div>

          {/* ══ SECTION 4: EDUCATION ══ */}
          <div className={`section ${activeSections.includes('sec-education') ? 'open' : ''}`} id="sec-education">
            <div className="section-head" onClick={() => handleSectionClick('sec-education')}>
              <div className="left">
                <div className="section-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/></svg>
                </div>
                <div>
                  <div className="section-title">Education</div>
                  <div className="section-desc">Qualifications and degrees</div>
                </div>
              </div>
              <div className="chevron"><svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M7 10l5 5 5-5z"/></svg></div>
            </div>
            <div className="section-body">

              <div className="subcard">
                <div className="subcard-title">Qualifications <span style={{ color: "#d9534f" }}>*</span></div>
                <div className="row" style={{ marginTop: 0 }}>
                  <div className="field">
                    <FormLabel title="Degree" />
                    <TextField
                      placeholder="Enter Degree" size="small" style={{ width: "100%" }}
                      error={validations.qualification?.status || false}
                      helperText={validations.qualification?.msg || ""}
                      value={employeeData.qualification || ""}
                      onChange={(e) => {
                        handleTextFieldChange(e.target.value, "qualification");
                        if (validations.qualification?.status) resetValidationField("qualification");
                      }}
                    />
                  </div>
                  <div className="field">
                    <FormLabel title="Graduation Date" />
                    <LocalizationProv dateAdapter={AdapterFns}>
                      <DesktopDatePicker
                        inputFormat="MM/dd/yyyy"
                        value={employeeData.graduationDate}
                        onChange={(value) => setEmployeeData((prevState) => ({ ...prevState, graduationDate: value }))}
                        renderInput={(params) => <TextField size="small" {...params} style={{ width: "100%" }} />}
                      />
                    </LocalizationProv>
                  </div>
                  <div className="field">
                    <FormLabel title="College" />
                    <TextField
                      placeholder="College Name" size="small" style={{ width: "100%" }}
                      error={validations.college?.status || false}
                      helperText={validations.college?.msg || ""}
                      value={employeeData.college || ""}
                      onChange={(e) => {
                        handleTextFieldChange(e.target.value, "college");
                        if (validations.college?.status) resetValidationField("college");
                      }}
                    />
                  </div>
                  <div className="field">
                    <FormLabel title="City" />
                    <TextField
                      placeholder="City Name" size="small" style={{ width: "100%" }}
                      error={validations.collegeCity?.status || false}
                      helperText={validations.collegeCity?.msg || ""}
                      value={employeeData.collegeCity || ""}
                      onChange={(e) => {
                        handleTextFieldChange(e.target.value, "collegeCity");
                        if (validations.collegeCity?.status) resetValidationField("collegeCity");
                      }}
                    />
                  </div>
                </div>
              </div>

            </div>
          </div>

          {/* ══ SECTION 5: PROJECTS & EXTRAS ══ */}
          <div className={`section ${activeSections.includes('sec-projects') ? 'open' : ''}`} id="sec-projects">
            <div className="section-head" onClick={() => handleSectionClick('sec-projects')}>
              <div className="left">
                <div className="section-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20 6h-4V4c0-1.1-.9-2-2-2h-4C8.9 2 8 2.9 8 4v2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-8-2h4v2h-4V4z"/></svg>
                </div>
                <div>
                  <div className="section-title">Projects &amp; extras</div>
                  <div className="section-desc">Project history and soft skills</div>
                </div>
              </div>
              <div className="chevron"><svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M7 10l5 5 5-5z"/></svg></div>
            </div>
            <div className="section-body">

              {/* Projects */}
              <div className="row">
                <div className="field">
                  <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <FormLabel title="Projects" required />
                    <AddEditIcons for="project" />
                  </Box>
                  <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="projects-list">
                      {(provided) => (
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                          {employeeData.projects?.map((project, index) => {
                            const isHidden = project.showInResume === false;
                            return (
                              <Draggable key={`project-${index}`} draggableId={`project-${index}`} index={index}>
                                {(provided, snapshot) => (
                                  <Box ref={provided.innerRef} {...provided.draggableProps} sx={{ paddingTop: "10px" }}>
                                    <Paper
                                      elevation={snapshot.isDragging ? 4 : 0}
                                      style={{
                                        backgroundColor: isHidden ? "#f9f9f9" : "#f3f3f3",
                                        border: isHidden ? "1px dashed #bdbdbd" : "0.5px solid #d9d9d9",
                                        width: "100%",
                                        transition: "box-shadow 0.2s ease",
                                      }}
                                    >
                                      <Box
                                        {...provided.dragHandleProps}
                                        style={{ padding: "8px 10px 4px 6px", display: "flex", alignItems: "flex-start", gap: "4px", cursor: "grab", userSelect: "none" }}
                                      >
                                        <Box sx={{ display: "flex", alignItems: "center", color: "#9e9e9e", paddingTop: "2px", flexShrink: 0 }}>
                                          <DragIndicator fontSize="small" />
                                        </Box>
                                        <Box sx={{ flex: 1, minWidth: 0 }}>
                                          <Box style={{ display: "flex", justifyContent: "space-between" }}>
                                            <Typography variant="body2" style={{ color: isHidden ? "#9e9e9e" : "inherit", fontStyle: isHidden ? "italic" : "normal" }}>
                                              {project.name}
                                            </Typography>
                                            <Box>
                                              <Typography variant="body2" style={{ color: isHidden ? "#9e9e9e" : "inherit" }}>
                                                {project.teamSize ? `Team Size: ${project.teamSize} ` : null}
                                                {project.teamSize && (project.years || project.months) ? "| " : null}
                                                {project.years || project.months ? `Time Span: ${processDurationString(project.years, project.months)}` : null}
                                              </Typography>
                                              <Typography variant="body2" style={{ color: isHidden ? "#9e9e9e" : "inherit" }}>
                                                {project.language ? `Language/s: ${project.language} ` : null}
                                                {project.language && project.role ? "| " : null}
                                                {project.role ? `Role: ${project.role}` : null}
                                              </Typography>
                                            </Box>
                                          </Box>
                                        </Box>
                                        <Box>
                                          <Tooltip title="Edit" placement="top">
                                            <IconButton
                                              size="small"
                                              onMouseDown={(e) => e.stopPropagation()}
                                              onClick={() => setModalStatus({ ...modalStatus, editProjects: true, editProjectIndex: index })}
                                              sx={{ flexShrink: 0, color: "primary.main" }}
                                            >
                                              <Edit fontSize="small" />
                                            </IconButton>
                                          </Tooltip>
                                          <Tooltip title={isHidden ? "Show in Resume" : "Hide from Resume"} placement="top">
                                            <IconButton
                                              size="small"
                                              onMouseDown={(e) => e.stopPropagation()}
                                              onClick={() => toggleProjectVisibility(index)}
                                              sx={{ flexShrink: 0, color: isHidden ? "#9e9e9e" : "primary.main" }}
                                            >
                                              {isHidden ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                            </IconButton>
                                          </Tooltip>
                                        </Box>
                                      </Box>
                                      <Paper elevation={0} style={{ backgroundColor: "transparent" }}>
                                        <Box style={{ padding: "6px 10px 10px 36px", whiteSpace: "pre-wrap", color: isHidden ? "#9e9e9e" : "inherit" }}>
                                          {project.description}
                                        </Box>
                                      </Paper>
                                      {isHidden && (
                                        <Box sx={{ px: "10px", pb: "8px" }}>
                                          <Typography variant="caption" sx={{ color: "#9e9e9e", fontStyle: "italic" }}>Hidden from resume</Typography>
                                        </Box>
                                      )}
                                    </Paper>
                                  </Box>
                                )}
                              </Draggable>
                            );
                          })}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                  {validations.projects?.status && <Alert severity="error">{validations.projects?.msg}</Alert>}
                </div>
              </div>

              {/* Soft Skills */}
              <div className="row">
                <div className="field">
                  <FormLabel title="Soft skills and other programming interests" required />
                  <div style={{ width: "100%", border: validations.otherInfo?.status ? "1px solid #d32f2f" : "none", borderRadius: "4px" }}>
                    <ReactQuill
                      theme="snow"
                      placeholder="e.g. Team leadership, mentoring, agile facilitation..."
                      value={employeeData.otherInfo ? (function(h){ let d = h; while(d.includes('&')){ let o = d; d = d.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>'); if(o===d) break; } return d; })(employeeData.otherInfo) : ""}
                      onChange={(val) => {
                        handleTextFieldChange(val, "otherInfo");
                        if (validations.otherInfo?.status) resetValidationField("otherInfo");
                      }}
                    />
                  </div>
                  {validations.otherInfo?.status && (
                    <FormHelperText style={{ color: "#d32f2f", marginLeft: "15px", marginTop: 0 }}>
                      {validations.otherInfo?.msg}
                    </FormHelperText>
                  )}
                </div>
              </div>

            </div>
          </div>

          {/* ══ SECTION 6: TEMPLATE & STYLE ══ */}
          <div className={`section ${activeSections.includes('sec-template') ? 'open' : ''}`} id="sec-template">
            <div className="section-head" onClick={() => handleSectionClick('sec-template')}>
              <div className="left">
                <div className="section-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M4 5v13h16V5H4zm7 11H6v-2h5v2zm0-4H6v-2h5v2zm0-4H6V6h5v2zm7 8h-5v-8h5v8z"/></svg>
                </div>
                <div>
                  <div className="section-title">Template &amp; style</div>
                  <div className="section-desc">Choose a CV layout and color theme</div>
                </div>
              </div>
              <div className="chevron"><svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M7 10l5 5 5-5z"/></svg></div>
            </div>
            <div className="section-body">

              {cvTemplates.length === 0 ? (
                <Typography variant="body2" color="text.secondary" style={{ padding: "12px 0" }}>Loading templates…</Typography>
              ) : (
                <div className="tpl-grid" style={{ gridTemplateColumns: "repeat(4,1fr)", gap: "12px", display: "grid", marginTop: "14px" }}>
                  {cvTemplates.map((tpl) => {
                    const isSelected = selectedTemplate === tpl.key;
                    let host = "http://localhost:3331";
                    try {
                      if (process.env.REACT_APP_API_URL) host = new URL(process.env.REACT_APP_API_URL).origin;
                    } catch (e) { console.error(e); }
                    const previewSrc = `${host}${tpl.previewUrl}`;
                    return (
                      <Box
                        key={tpl.key}
                        onClick={() => {
                          setSelectedTemplate(tpl.key);
                          setPrimaryColor(tpl.defaultPrimaryColor || "");
                          setSecondaryColor(tpl.defaultSecondaryColor || "");
                          setEmployeeData((p) => ({ ...p, template: tpl.key, primaryColor: tpl.defaultPrimaryColor || "", secondaryColor: tpl.defaultSecondaryColor || "" }));
                        }}
                        sx={{
                          cursor: "pointer", borderRadius: "8px", overflow: "hidden",
                          border: isSelected ? `2.5px solid ${tpl.defaultPrimaryColor || "#1976d2"}` : "2px solid #e2e5e9",
                          background: "#fff",
                          boxShadow: isSelected ? `0 4px 12px rgba(0,0,0,0.08), 0 0 0 3px ${tpl.defaultPrimaryColor || "#1976d2"}33` : "0 2px 6px rgba(0,0,0,0.03)",
                          transition: "all 0.2s ease-in-out",
                          "&:hover": { borderColor: tpl.defaultPrimaryColor || "#1976d2", transform: "translateY(-3px)", boxShadow: "0 6px 16px rgba(0,0,0,0.08)" },
                        }}
                      >
                        <Box sx={{ width: "100%", height: "120px", overflow: "hidden", borderBottom: "1px solid #f0f0f0", position: "relative", backgroundColor: "#fcfcfc", containerType: "inline-size" }}>
                          <iframe src={previewSrc} title={tpl.name} scrolling="no"
                            style={{ width: "794px", height: "1050px", border: "none", pointerEvents: "none", transform: "scale(calc(100cqw / 794px))", transformOrigin: "top left", position: "absolute", top: 0, left: 0 }}
                          />
                          {isSelected && (
                            <Box sx={{ position: "absolute", top: 8, right: 8, backgroundColor: tpl.defaultPrimaryColor || "#1976d2", color: "#fff", borderRadius: "50%", width: 22, height: 22, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "0.75rem", fontWeight: "bold", boxShadow: "0 2px 4px rgba(0,0,0,0.2)" }}>✓</Box>
                          )}
                        </Box>
                        <Box sx={{ padding: "6px 10px" }}>
                          <Typography variant="subtitle2" sx={{ fontWeight: 700, color: isSelected ? tpl.defaultPrimaryColor || "#1976d2" : "#1f2937", fontSize: "0.85rem" }}>
                            {tpl.name}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })}
                </div>
              )}

              {/* Color theme */}
              {cvTemplates.length > 0 && (
                <Box sx={{ mt: 2 }}>
                  <div className="subcard-title">Color theme</div>
                  <div className="theme-dots" style={{ display: "flex", gap: "8px", marginTop: "8px", flexWrap: "wrap", alignItems: "center" }}>
                    {[
                      { label: "Teal & Amber", primary: "#0C766F", secondary: "#B45309" },
                      { label: "Indigo & Gold", primary: "#4338CA", secondary: "#7D5A07" },
                      { label: "Crimson & Amber", primary: "#BE123C", secondary: "#B45309" },
                      { label: "Forest & Amber", primary: "#15803D", secondary: "#B45309" },
                      { label: "Navy & Steel", primary: "#1E3A5F", secondary: "#3D6EA5" },
                      { label: "Plum & Gold", primary: "#6D28D9", secondary: "#7D5A07" },
                      { label: "Royal Blue & Coral", primary: "#2563EB", secondary: "#C2410C" },
                      { label: "Charcoal & Rose", primary: "#1F2937", secondary: "#BE123C" },
                      { label: "Emerald & Navy", primary: "#047857", secondary: "#1E3A5F" },
                      { label: "Burgundy & Mustard", primary: "#7F1D1D", secondary: "#A16207" },
                      ...(selectedTemplate === "template7_lumen" ? [{ label: "Black Only", primary: "#000000", secondary: "#000000" }] : []),
                    ].map((preset) => {
                      const isActive = primaryColor === preset.primary && (secondaryColor || "") === (preset.secondary || "");
                      return (
                        <Tooltip key={preset.label} title={preset.label} placement="top">
                          <Box
                            onClick={() => {
                              setPrimaryColor(preset.primary);
                              setSecondaryColor(preset.secondary || "");
                              setEmployeeData((p) => ({ ...p, primaryColor: preset.primary, secondaryColor: preset.secondary || "" }));
                            }}
                            sx={{
                              width: 24, height: 24, borderRadius: "50%", cursor: "pointer",
                              background: preset.secondary ? `linear-gradient(135deg, ${preset.primary} 55%, ${preset.secondary} 100%)` : preset.primary,
                              border: isActive ? "2.5px solid #1e293b" : "2px solid #fff",
                              boxShadow: isActive ? `0 0 0 1.5px ${preset.primary}` : "0 1px 3px rgba(0,0,0,0.15)",
                              transition: "all 0.15s ease",
                              "&:hover": { transform: "scale(1.15)" },
                            }}
                          />
                        </Tooltip>
                      );
                    })}
                  </div>
                  <div style={{ display: "flex", gap: "16px", marginTop: "12px", alignItems: "center" }}>
                    {/* Custom color pickers */}
                    <Tooltip title="Custom Primary Color" placement="top">
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                        <Box component="label" sx={{ width: 24, height: 24, borderRadius: "50%", background: primaryColor || "#cccccc", border: "2px solid #fff", boxShadow: "0 1px 3px rgba(0,0,0,0.2)", cursor: "pointer", position: "relative", overflow: "hidden", "&:hover": { transform: "scale(1.1)" }, transition: "transform 0.15s ease" }}>
                          <input type="color" value={primaryColor || "#0d9488"}
                            onChange={(e) => { setPrimaryColor(e.target.value); setEmployeeData((p) => ({ ...p, primaryColor: e.target.value })); }}
                            style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: 0, cursor: "pointer", border: "none" }}
                          />
                        </Box>
                        <Typography variant="caption" sx={{ color: "#6b7280", fontSize: "0.65rem" }}>Primary</Typography>
                      </Box>
                    </Tooltip>
                    <Tooltip title="Custom Secondary Color" placement="top">
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                        <Box component="label" sx={{ width: 24, height: 24, borderRadius: "50%", background: secondaryColor || "#cccccc", border: "2px solid #fff", boxShadow: "0 1px 3px rgba(0,0,0,0.2)", cursor: "pointer", position: "relative", overflow: "hidden", "&:hover": { transform: "scale(1.1)" }, transition: "transform 0.15s ease" }}>
                          <input type="color" value={secondaryColor || "#f59e0b"}
                            onChange={(e) => { setSecondaryColor(e.target.value); setEmployeeData((p) => ({ ...p, secondaryColor: e.target.value })); }}
                            style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: 0, cursor: "pointer", border: "none" }}
                          />
                        </Box>
                        <Typography variant="caption" sx={{ color: "#6b7280", fontSize: "0.65rem" }}>Secondary</Typography>
                      </Box>
                    </Tooltip>
                  </div>
                </Box>
              )}

            </div>
          </div>

          {/* ── Footer actions ── */}
          <div className="footer-actions">
            <LoadingButton
              variant="outlined"
              style={{ minWidth: "100px" }}
              loading={generatingPreview}
              onClick={generatePreview}
            >
              {generatingPreview ? "" : "Preview"}
            </LoadingButton>
            <Button
              variant="contained"
              onClick={() => {
                const action = id ? "update" : "create";
                if (window.confirm(`Are you sure you want to ${action} this profile?`)) {
                  if (id) { updateEmployeeProfile(); } else { saveEmployeeProfile(); }
                }
              }}
            >
              {id ? "Update" : "Create"}
            </Button>
          </div>

        </div>{/* end .main */}
      </div>{/* end .layout */}

      {validations.profilePicUploadErr?.status && (
        <Alert severity="error" style={{ marginTop: "10px" }}>{validations.profilePicUploadErr?.msg}</Alert>
      )}
      {modalStatus.editExpertise ? (
        <EditExpertiseModal
          open={modalStatus}
          setOpen={setModalStatus}
          employeeData={employeeData}
          setEmployeeData={setEmployeeData}
          expertiseOptions={expertiseOptions}
        />
      ) : null}
      {modalStatus.addExpertise ? (
        <AddExpertiseModal
          open={modalStatus}
          setOpen={setModalStatus}
          employeeData={employeeData}
          setEmployeeData={setEmployeeData}
          fetchExpertiseOptions={fetchExpertiseOptions}
        />
      ) : null}
      {modalStatus.editExperience ? (
        <EditExperienceModal
          open={modalStatus}
          setOpen={setModalStatus}
          employeeData={employeeData}
          setEmployeeData={setEmployeeData}
          skillOptions={skillOptions[employeeData.expertise[0]]}
        />
      ) : null}
      {modalStatus.addExperience ? (
        <AddExperienceModal
          open={modalStatus}
          setOpen={setModalStatus}
          employeeData={employeeData}
          setEmployeeData={setEmployeeData}
          skillOptions={skillOptions[employeeData.expertise[0]]}
          expertiseOptions={expertiseOptions}
        />
      ) : null}
      <AddToolModal
        open={modalStatus}
        setOpen={setModalStatus}
        employeeData={employeeData}
        setEmployeeData={setEmployeeData}
        toolsList={toolsList}
        fetchToolsList={fetchToolsList}
      />
      {modalStatus.editTools ? (
        <EditToolsModal
          open={modalStatus}
          setOpen={setModalStatus}
          employeeData={employeeData}
          setEmployeeData={setEmployeeData}
          toolsList={toolsList}
        />
      ) : null}
      {modalStatus.addLanguage ? (
        <AddLanguageModal
          open={modalStatus}
          setOpen={setModalStatus}
          employeeData={employeeData}
          setEmployeeData={setEmployeeData}
          languageOptions={languageOptions}
          activeLanguages={enableLanguageOptions}
          fetchLanguageOptions={fetchLanguageOptions}
        />
      ) : null}
      {modalStatus.editLanguages ? (
        <EditLanguageModal
          open={modalStatus}
          setOpen={setModalStatus}
          employeeData={employeeData}
          setEmployeeData={setEmployeeData}
          languageOptions={languageOptions}
          activeLanguages={enableLanguageOptions}
        />
      ) : null}
      {modalStatus.addNR ? (
        <AddNRModal
          open={modalStatus}
          setOpen={setModalStatus}
          fetchReligionOptions={fetchReligionOptions}
          fetchNationalityOptions={fetchNationalityOptions}
        />
      ) : null}
      <AddProjectModal
        open={modalStatus}
        setOpen={setModalStatus}
        employeeData={employeeData}
        setEmployeeData={setEmployeeData}
        resetValidationField={resetValidationField}
        skillOptions={skillOptions[employeeData.expertise[0]]}
      />
      {modalStatus.editProjects ? (
        <EditProjectModal
          open={modalStatus}
          setOpen={setModalStatus}
          employeeData={employeeData}
          setEmployeeData={setEmployeeData}
          skillOptions={skillOptions[employeeData.expertise[0]]}
        />
      ) : null}
      {modalStatus.addEditSkill ? (
        <AddEditSkillModal
          open={modalStatus}
          setOpen={setModalStatus}
          employeeData={employeeData}
          expertiseOptions={expertiseOptions}
          skills={skillOptions[employeeData.expertise[0]]}
          setSkillOptions={setSkillOptions}
          setDisplayAlert={setDisplayAlert}
          setAlertMessage={setAlertMessage}
          setAlertVariant={setAlertVariant}
        />
      ) : null}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={successMsg}
        TransitionComponent={Slide}
        autoHideDuration={2000}
        onClose={() => {
          setSuccessMsg(false);
          navigate("/employee-profiles/list");
        }}
      >
        <Alert serverity="success">
          Employee Profile Created Successfully!
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={updateMsg}
        TransitionComponent={Slide}
        autoHideDuration={2000}
        onClose={() => {
          setUpdateMsg(false);
          // navigate("/employee-profiles/list");
        }}
      >
        <Alert serverity="success">
          Employee Profile Updated Successfully!
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={displayAlert}
        onClose={closeAlertMessage}
        message={displayAlert}
        key={"system-message"}
        autoHideDuration={2000}
      >
        <Alert severity={alertVariant}>
          {alertMessage}
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            sx={{ ml: 2 }}
            onClick={closeAlertMessage}
          >
            <Close fontSize="small" />
          </IconButton>
        </Alert>
      </Snackbar>
      <ProfilePreviewDialog
        open={showProfilePreviewDialog}
        setOpen={setProfilePreviewDialog}
        sourcePath={previewSourcePath}
      />
    </>
  );
});

export default Create;
